import styled from 'styled-components';
import { Modal as ModalRoot } from '@indigo-ag/component-module';

export const Modal = styled(ModalRoot)`
  min-width: 35rem;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: right;
  gap: 0.5rem;
  padding: 1rem;
`;

export const ExceptionButton = styled.button`
  height: 34px;
  cursor: pointer;
  border: none;
  margin: 0.25rem;
  padding-top: 0.375rem;
  vertical-align: bottom;
  color: #ffa500;
  border-bottom: 0.25rem solid transparent;
  background-color: transparent;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  opacity: 1;
  transition: opacity 0.2s;

  &:hover {
    color: #ff8c00;
    border-bottom: 0.25rem solid #ffa500;
  }
`;
